import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { PrimeReactProvider, addLocale } from 'primereact/api';
import './index.css';

// Adicionando um local personalizado
addLocale('pt-BR', {
    firstDayOfWeek: 0,
    dayNames: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
    dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
    dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
    monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
    monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
    paginator: {
        firstPage: "Primeira página",
        lastPage: "Última página",
        prevPage: "Página anterior",
        nextPage: "Próxima página",
        rowsPerPage: "Itens por página",
        rangeSeparator: "de"
    },
    today: 'Hoje',
    clear: 'Limpar', 
    close: "Fechar", 
    accept: "Aceitar", 
    reject: "Rejeitar",
    apply :"Aplicar",
    contains : "Contém",
    startsWith :"inicia com",
    notContains : "Não contém", 
    endsWith : "Termina com",
    equals :"Igual a", 
    notEquals :"Diferente de",
    emptyFilterMessage: "Nenhum resultado encontrado",
    emptyMessage: "Nenhum registro disponível"
});

const primeReactConfig = {
    appendTo: 'self',
    styleContainer: document.head,
    locale: 'pt-BR',
    pt: {}, // Defina propriedades de Pass Through conforme necessário
    ptOptions: {}, // Defina opções adicionais de Pass Through conforme necessário
    unstyled: false,
    ripple: true,
    inputStyle: 'outlined',
    autoZIndex: true,
    zIndex: {
        modal: 1100,
        overlay: 1000,
        menu: 1000,
        tooltip: 1100
    }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <PrimeReactProvider value={primeReactConfig}>
            <App />
        </PrimeReactProvider>
    </React.StrictMode>
);
